exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-2b5c009c] .el-checkbox__label,[data-v-2b5c009c] .el-radio__label{display:inline;white-space:normal}.ql-editor[data-v-2b5c009c]{padding-top:0;padding-left:0;padding-right:0}", ""]);

// exports
